<template>
	<div class="sa-list-component">
		<div class="sa-list-component-body">
			<div class="b-table-sticky-header">
				<b-table sticky-header ref="table" :busy="isBusy" stacked="lg" striped hover :items="items"
					:fields="columnVisibile" sort-icon-left head-variant="light" class="sa-b-table"
					:selectable="selectable" select-mode="single" @row-selected="onRowSelectedArticoliItems">
					<template #cell(index)="row">
						{{ (currentPage - 1) * perPage + row.index + 1 }}
					</template>
					<template #cell(nomeArticolo)="row">
						<span style="font-weight: bold">{{ row.item.nomeArticolo }}</span>
						<span style="display: block; font-size: 0.95rem; font-style: italic">{{
							row.item.descrizioneArticolo }}</span>
					</template>
					<template #cell(giacenze)="{ item }">
						<div class="inventory-status d-flex flex-column gap-1">
							<div :class="getGiacenzaClass(item.giacenze, item.sottoscortaArticolo)"
								class="fw-bold d-flex align-items-center">
								<span>📦 {{ getGiacenzaTotale(item) }}</span>
								<font-awesome-icon v-if="item.giacenze <= item.sottoscortaArticolo"
									icon="exclamation-triangle" class="m-2 text-warning" />
							</div>
							<div class="text-muted fst-italic small-details">
								<div>
									🏗️ <b>{{ getGiacenzaFormato(item) }}</b> {{ item.descrizioneMultiplo }}
								</div>
								<div>
									🧱 <b>{{ getGiacenzaBase(item) }}</b> {{ item.descrizioneMultiploBase ?
										item.descrizioneMultiploBase : item.descrizioneMultiplo }}
								</div>
							</div>
						</div>
					</template>
					<template v-slot:cell(actions)="row">
						<b-container class="bv-example-row">
							<b-button size="sm" v-b-tooltip.hover title="Visualizza Articolo"
								variant="outline-secondary" class="mr-1 no-text"
								@click="onClickViewArticoloMagazzino(row.item)">
								<font-awesome-icon icon="eye" />
							</b-button>
							<b-button size="sm" v-b-tooltip.hover class="mr-1 no-text" title="Modifica Articolo"
								variant="outline-success" @click="onClickModificaArticoloMagazzino(row.item)">
								<font-awesome-icon icon="edit" />
							</b-button>

							<b-button size="sm" v-b-tooltip.hover class="mr-1 no-text" title="Rimuovi Articolo"
								variant="outline-danger" @click="onClickRimuoviArticoloMagazzino(row.item)">
								<font-awesome-icon icon="trash" />
							</b-button>
						</b-container>
					</template>
				</b-table>
			</div>
		</div>
		<div class="sa-list-component-invisible">
			<magazzino-articoli-anagrafica-edit-component v-if="showAnagraficaComponent"
				ref="cmpMagazzinoArticoliAnagraficaModalEdit" @articoloMagazzinoDelete="onArticoloDeleted" />
		</div>
		<div class="sa-list-component-footer" v-if="pagination">
			<b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
				<b-col lg="3">
					<p>{{ this.$i18n.t("patients.lblTotalRecords") }}: {{ rows }}</p>
				</b-col>
				<b-col lg="9">
					<b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right"
						size="sm"></b-pagination>
				</b-col>
			</b-row>
		</div>
	</div>
</template>
<script>
import UtilityMixin from "../../utility/UtilityMixin";
import MagazzinoArticoliAnagraficaEditComponent from "./MagazzinoArticoliAnagraficaEditComponent.vue";
export default {
	name: "MagazzinoArticoliListComponent",
	mixins: [UtilityMixin],
	inject: ["openShowModalLoading", "closeShowModalLoading"],
	components: { MagazzinoArticoliAnagraficaEditComponent },
	props: {
		selectable: { type: Boolean, default: false },
		component: { type: Boolean, default: false },
		perPageCustom: { type: Number, default: 100 },
		tableHideColumn: {
			type: Array,
			default: () => {
				return ["codiceAzienda", "dataScadenza"];
			},
		},
		pagination: { type: Boolean, default: true },
	},
	mounted() {
		if (this.perPageCustom != 100) {
			this.perPage = this.perPageCustom;
		}
	},
	computed: {
		columnVisibile() {
			return this.fields.filter((e) => !this.tableHideColumn.includes(e.key));
		},
	},
	watch: {
		items: function (params) {
			console.log(params.length);
			if (params.length == 1) {
				this.$nextTick(() => {
					if (this.$refs.table) {
						this.$refs.table.selectRow(0);
					}
				});
			}
		},
		currentPage: function () {
			if (this.pagination) {
				this.loadDataArticoli();
			}
		},
	},
	data() {
		return {
			isBusy: false,
			rows: 0,
			perPage: 100,
			currentPage: 1,
			showAnagraficaComponent: false,
			pathResource: "/magazzinoarticoli/giacenza/codici",
			linkEdit: "/magazzino/articoli",
			linkView: "/magazzino/articoli/view",
			filtroCustom: {},
			btnAggiungi: false,
			items: [],
			filtroArticoliMagazzino: { nomeArticolo: null, codiceTipoArticolo: null, stato: null },
			fields: [
				{
					label: "",
					key: "index",
					sortable: true,
					thStyle: "width: 2rem",
				},
				{
					label: "Codice Articolo",
					key: "codiceArticolo",
					sortable: true,
				},
				{
					label: "Codice Prodotto",
					key: "codiceProdotto",
					sortable: true,
				},
				{
					label: "Codice Matricola/Lotto",
					key: "lottoMatricola",
					sortable: true,
				},
				{
					label: "Codice Azienda",
					key: "codiceAzienda",
					sortable: true,
				},
				{
					label: "Magazzino",
					key: "magazzinoDescrizione",
					sortable: true,
				},
				{
					label: "Categoria",
					key: "categoria",
					sortable: true,
				},
				{
					label: "Nome",
					key: "nomeArticolo",
					sortable: true,
				},
				{
					label: "Marca",
					key: "marca",
					sortable: true,
				},
				{
					label: "Data Produzione",
					key: "dataProduzione",
					sortable: true,
					formatter: (value) => {
						return this.formatDate(value);
					},
				},
				{
					label: "Data Scadenza",
					key: "dataScadenza",
					sortable: true,
					formatter: (value) => {
						return this.formatDate(value);
					},
				},
				{
					label: "Giacenze",
					key: "giacenze",
					thStyle: "width: 8rem; white-space: nowrap;",
					tdClass: "text-nowrap",
					sortable: true,
				},
				{ class: "sa-table-column-action-double", key: "actions", label: "" },
			],
		};
	},
	methods: {
		onRowSelectedArticoliItems(item) {
			this.$emit("onRowSelectedArticoliItems", item);
		},
		getGiacenzaTotale(item) {
			return item.giacenze == 0 ? item.giacenze : item.giacenze.toFixed(1);
		},
		getGiacenzaFormato(item) {
			return item.giacenzaFormato;
		},
		getGiacenzaBase(item) {
			return item.giacenzaBase;
		},
		loadDataArticoli(filter) {
			let me = this;
			me.$emit("beforeLoadData");
			let filtro = {};
			this.openShowModalLoading();
			if (!me.component) {
				if (sessionStorage["filtroMagazzino"]) {
					me.filtroArticoliMagazzino = JSON.parse(sessionStorage["filtroMagazzino"]);
				}
				filtro = { ...me.filtroArticoliMagazzino };
				me.$emit("updateFilter", me.filtroArticoliMagazzino);
				filtro = { ...filtro, forPage: me.perPage, page: me.currentPage };
			} else {
				filtro = filter;
			}
			filtro = { ...filtro };
			console.log(filtro);

			UtilityMixin.methods.loadDataResources(me.pathResource, filtro, me.loadDataArticoliSuccess, me.loadDataArticoliError);
		},
		loadDataArticoliSuccess(response) {
			let me = this;
			me.items = response.data.data.list;
			me.rows = response.data.data.recordsNumber;
			this.$emit("updateRowNumberGiacenza", me.rows);
			me.$emit("afterLoadData");
			this.closeShowModalLoading();
		},
		loadDataArticoliError(response) {
			let me = this;
			me.$emit("afterLoadData");
			response;
			this.closeShowModalLoading();
		},
		onClickRimuoviArticoloMagazzino(item) {
			let me = this;
			me.showAnagraficaComponent = true;
			me.$nextTick(() => {
				me.$refs.cmpMagazzinoArticoliAnagraficaModalEdit.onDeleteArticoloMagazzino(item);
			});
		},
		onArticoloDeleted() {
			let me = this;
			me.showAnagraficaComponent = false;
			me.loadDataArticoli();
		},
		onClickViewArticoloMagazzino(item) {
			let me = this;
			me.$router.push("/magazzino/articoli/view/" + item.id);
		},
		onClickModificaArticoloMagazzino(item) {
			let me = this;
			me.$router.push("/magazzino/articoli/edit/" + item.id);
		},
		getGiacenzaClass(giacenza, sottoscorta) {
			return giacenza <= sottoscorta ? "text-danger font-weight-bold" : "text-success font-weight-bold";
		},
	},
};
</script>
